import { map } from 'rxjs/operators/map';
import { combineEpics } from 'redux-observable';

import getLoginUrl from '../routes/getLoginUrl';
import { whenError, whileOnRoute } from './helpers/operators';
import { NOT_AUTHORIZED, AUTHENTICATION_FAILED } from '../constants/errors';
import { setUrl } from '../actions/routes';

// This epic redirects to the login screen if authentication fails
// for any apollo action. The login page will redirect back to the current
// route after login
const redirectIfAuthFailedEpic = (action$, store, { baseUrl }) =>
  action$.pipe(
    whenError(NOT_AUTHORIZED, AUTHENTICATION_FAILED),
    whileOnRoute(action$),
    map(([, route]) => setUrl(getLoginUrl(baseUrl, route.location.pathname)))
  );

const authEpic = combineEpics(redirectIfAuthFailedEpic);

export default authEpic;
